import { t } from 'i18next';
import * as Icons from '@mui/icons-material';
import { BakeasyButton, BakeasyButtonProps } from './BakeasyButton';

export function Export(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('EXPORT')} startIcon={<Icons.FileDownload />} />;
}

export function Filter(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('FILTER')} startIcon={<Icons.FilterAltOutlined />} />;
}

export function Add(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('ADD')} startIcon={<Icons.Add />} />;
}

export function Create(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('CREATE')} />;
}

export function Cancel(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('CANCEL')} variant={'outlined'} />;
}

export function NewMsg(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('NEW_MESSAGE')} startIcon={<Icons.Create />} />;
}

export function Update(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('UPDATE')} />;
}

export function Print(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('PRINT')} startIcon={<Icons.Print />} />;
}

export function Edit(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('EDIT')} startIcon={<Icons.Edit />} />;
}

export function Send(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('SEND')} startIcon={<Icons.Send />} />;
}

export function Upload(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('UPLOAD')} startIcon={<Icons.FileUpload />} />;
}

export function NewOrderSummary(props: BakeasyButtonProps) {
  return <BakeasyButton {...props} label={t('NEW_ORDER_SUMMARY')} startIcon={<Icons.Download />} />;
}
